/* eslint-disable eqeqeq */
import { useState, useEffect, JSXElementConstructor, Key, ReactElement, ReactNode, useRef, useMemo } from 'react';
import {
    copyIcon,
    languageIcon,
    plusIcon,
    speakerIcon,
    toggleButtonRightArrowIcon,
    uploadFileIcon,
} from 'assets/icons';
import SourceInfo from 'components/SourceInfo';
import ReactMarkdown from 'react-markdown';
import styles from 'assets/styles/ai-chat-bot/markdownRenderer.module.css'; // Import your CSS module for React markdown
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { getLanguage, startConversation_v2 } from 'services/coversationService';
import { toast, ToastContent } from 'react-toastify';
import Modal from 'pages/modal';
import * as myconst from "../../constants"
import { useDispatch, useSelector } from 'react-redux';
import { handleDocuMateCalled, handleLoader, setDocuMateValue } from 'redux/counterSlice';
import UploadConfirmation from 'components/UploadConfirmation';
import { postFileProcessing } from 'services/documentApprovalService';
import Iframe from 'components/Iframe';
import { confirmPopup, ConfirmPopup } from 'primereact/confirmpopup';
import { deleteConversationEmail, emailHistory, emailHistoryById, sentimentAnalysis, sentimentAnalysisFilter } from 'services/emailService';
import { Card } from 'primereact/card';
import ConversationList from 'components/ai-chat-board/ConversationList';
import { Button } from 'primereact/button';
import { handleActive } from 'redux/persistentSlice';
import { Dropdown } from 'primereact/dropdown';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputText } from 'primereact/inputtext';
import _ from 'lodash';
const moment = require('moment');

function SentimentAnalysis() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const params = useParams();
    const editDeleteContainerRef = useRef(null);
    const sentimentAnalysisPdf = useSelector((state: any) => state.counter.sentimentAnalysisPdf);
    const pdfURl = window.location.origin === 'https://ron.rysun.in:3001' ?
                    "https://ron-api1.rysun.in:8003/opt/ron_app_data/Ron_Middleware/production_apis/document_comparison/sentiment_document"
                    : window.location.origin === 'https://shoptalk.rysun.com' ?
                    "https://shoptalk.rysun.com/var/www/html/document_comparison/sentiment_document" 
                    : "http://10.1.1.77/opt/ron_app_data/Ron_Middleware/stage_apis/RonMiddleWareApi/ron_project"
    const promptText = "This chat will be deleted, along with its sentiment analysis and related responses from your RysunAI activity."
    const [sentimentPdf, setSentimentPdf] = useState("")
    const [sentimentFileName, setSentimentFileName] = useState("")
    const [sentimentData, setSentimentData] = useState<any>([])
    const [allSentimentData, setAllSentimentData] = useState<any>({});
    const [totalRatings, setTotalRatings] = useState(0);
    const [current, setCurrent] = useState<any>(null);
    const [data, setData] = useState({});
    const [visibleRight, setVisibleRight] = useState<boolean>(false);
    const [hover, setHover] = useState(null);
    const [showEditDelete, setShowEditDelete] = useState({});
    const [emailData, setEmailData] = useState({});
    const [isDeleteClicked, setIsDeleteClicked] = useState([]);
    const [delId, setDelId] = useState('');
    const [searchItem, setSearchItem] = useState("");
    const [filteredData, setFilteredData] = useState([]);
    const [filterRating, setFilterRating] = useState<any>("");
    const [filterSentiment, setFilterSentiment] = useState<any>("");
    const reviewsRef = useRef<any>(null);
    const [deleteConfirmation, setDeleteConfirmation] = useState<any>({
        date: null,
        index: null,
    });
    const ratings = [
        { name: 'All', code: 'All' },
        { name: '0 - 1 Star', code: '0-1' },
        { name: '1 - 2 Stars', code: '1-2' },
        { name: '2 - 3 Stars', code: '2-3' },
        { name: '3 - 4 Stars', code: '3-4' },
        { name: '4 - 5 Stars', code: '4-5' }
    ];
    const sentiments = [
        { name: 'All', code: 'All' },
        { name: 'Neutral', code: 'Neutral' },
        { name: 'Positive', code: 'Positive' },
        { name: 'Negative', code: 'Negative' }
    ];

    const fetchSentimentData = async () => {
        const result = sentimentAnalysisPdf
        setAllSentimentData(result)
        setSentimentData(result.sentiment)
        setFilteredData(result.sentiment)
        let cleanedFileData = result?.file_path.replace(/\/Ron_Project/g, '');
        const totalRating: any = Object.values(result?.rating_count).reduce((sum: any, count: any) => sum + count, 0);
        setTotalRatings(totalRating)
        const originalFileName = result?.file_name.split('___')[0] + '.pdf';
        setSentimentFileName(originalFileName)
        setSentimentPdf(`${process.env.REACT_APP_DOC_PROCESSING_PDF}${cleanedFileData}`)
        if (params.id === 'new-sentiment') {
            navigate(`/sentiment-analysis/${result.conversation_id}`);
            // await getConversations();
        }
        dispatch(handleLoader(false));
    }

    const handleRatingFilter = (e: any) => { 
        const updatedRating = e.value; 
        // setSearchItem("")
        setFilterRating(updatedRating); 
        handleFilter(updatedRating, filterSentiment, searchItem); 
    }
    
    const handleSentimentFilter = (e: any) => {
        const updatedSentiment = e.value; 
        // setSearchItem("")
        setFilterSentiment(updatedSentiment); 
        handleFilter(filterRating, updatedSentiment, searchItem); 
    }
    
    const handleFilter = async (rating: any, sentiment: any, searchItem: any) => {
        if (reviewsRef.current) {
            reviewsRef.current.scrollTo({ top: 0, behavior: 'smooth' });
        }
        dispatch(handleLoader(true));
        try {
            const body = {
                conversation_id: allSentimentData?.conversation_id ? allSentimentData?.conversation_id : "",
                message_id: allSentimentData?.message_id ? allSentimentData?.message_id : "",
                reviews_filter: rating ? (rating?.code === "All") ? "" : rating?.code : "",
                sentiment_filter: sentiment ? (sentiment?.code === "All") ? "" : sentiment?.code : "",
                search: searchItem ? searchItem : ""
            }
            const { result, error } = await sentimentAnalysisFilter(body);
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            setEmailData(result?.document);
            setAllSentimentData(result?.document)
            const isInvalidRating = result?.document.sentiment.some((item: any) => {
                const [ratingValue] = item.Rating.split('/').map(parseFloat);
                return ratingValue > 5;
            });
            
            if (isInvalidRating) {
                setSentimentData([]);
                setFilteredData([]);
            } else {
                setSentimentData(result?.document.sentiment);
                setFilteredData(result?.document.sentiment);
            }
            // setSentimentData(result?.document.sentiment)
            // setFilteredData(result?.document.sentiment)
            // let cleanedFileData = result?.document?.file_path.replace(/\/Ron_Project/g, '');
            const totalRating: any = Object.values(result?.document?.rating_count).reduce((sum: any, count: any) => sum + count, 0);
            setTotalRatings(totalRating)
            // const originalFileName = result?.latest_record?.file_name.split('___')[0] + '.pdf';
            // setSentimentFileName(originalFileName)
            // setSentimentPdf(`http://10.1.1.77/opt/ron_app_data/Ron_Middleware/stage_apis/RonMiddleWareApi/ron_project${cleanedFileData}`)
            dispatch(handleLoader(false));
        } catch (error) {
            toast.error(error as ToastContent<unknown>, {
                style: {
                backgroundColor: '#F1F1F1', // Grey background
                }
            })
            dispatch(handleLoader(false));
        }
    }

    useEffect(() => {
        setCurrent(params.id);
    })

    const handleGetConversation = async (id: any) => {
        if (reviewsRef.current) {
            reviewsRef.current.scrollTo({ top: 0, behavior: 'smooth' });
        }
        setSearchItem("")
        setFilterRating("")
        setFilterSentiment("")
        const startTime = performance.now(); // Start the timer
        dispatch(handleLoader(true));
        try {
            // setUserQuery([]);
            // setAnswer([]);
            setCurrent(id);
            const { result, error } = await emailHistoryById(id, "document_sentiment");
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            setEmailData(result?.latest_record);
            const settings = result?.latest_record.settings;
            // dispatch(handleObjective({ name: settings.objective }));
            // dispatch(handleDesiredOutcome({ name: settings.desired_outcome }));
            // dispatch(handleConstraints({ name: settings.constraints[0] }));
            const endTime = performance.now(); // End the timer
            const elapsedTime = endTime - startTime; // Calculate elapsed time
            setAllSentimentData(result?.latest_record)
            const isInvalidRating = result?.latest_record.sentiment.some((item: any) => {
                const [ratingValue] = item.Rating.split('/').map(parseFloat);
                return ratingValue > 5;
            });
            
            if (isInvalidRating) {
                setSentimentData([]);
                setFilteredData([]);
            } else {
                setSentimentData(result?.latest_record.sentiment);
                setFilteredData(result?.latest_record.sentiment);
            }
            // setSentimentData(result?.latest_record.sentiment)
            // setFilteredData(result?.latest_record.sentiment)
            let cleanedFileData = result?.latest_record?.file_path.replace(/\/Ron_Project/g, '');
            const totalRating: any = Object.values(result?.latest_record?.rating_count).reduce((sum: any, count: any) => sum + count, 0);
            setTotalRatings(totalRating)
            const originalFileName = result?.latest_record?.file_name.split('___')[0] + '.pdf';
            setSentimentFileName(originalFileName)
            setSentimentPdf(`${process.env.REACT_APP_DOC_PROCESSING_PDF}${cleanedFileData}`)
            dispatch(handleLoader(false));
        } catch (error) {
            toast.error(error as ToastContent<unknown>, {
                style: {
                backgroundColor: '#F1F1F1', // Grey background
                }
            })
            dispatch(handleLoader(false));
        }
    };

    const handleDelete = async (date: any, index: any) => {
        try {
            const { result, error } = await deleteConversationEmail(delId, "document_sentiment");
            if (error) {
                throw error
            }
            if (result?.error) {
                const updatedIsDeleteClicked: any = [...isDeleteClicked];
                updatedIsDeleteClicked[index] = false;
                setIsDeleteClicked(updatedIsDeleteClicked);
                throw result.error
            }
            toast.success('Conversation deleted successfully', {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            });
            if (delId === params.id) {
                // handleNewChatButton();
                setHover(null);
                setCurrent(null);
                navigate(`/sentiment-analysis/new-sentiment`);
                // setVisibleRight(false)
                setAllSentimentData([]);
                setSentimentData([]);
                setFilteredData([]);
                dispatch(handleActive("sentimentAnalysis"))
            }
            const updatedIsDeleteClicked: any = [...isDeleteClicked];
            updatedIsDeleteClicked[index] = false;
            setIsDeleteClicked(updatedIsDeleteClicked);
            getConversations();

        } catch (error) {
            toast.error(error as ToastContent<unknown>, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            });
        }
    };

    const handleDeleteIconClicked = (date: any, index: any, id: any) => {
        setDelId(id);
        const updatedIsDeleteClicked: any = [...isDeleteClicked];
        updatedIsDeleteClicked[index] = true;
        setIsDeleteClicked(updatedIsDeleteClicked);
        setDeleteConfirmation({ date, index });
        if (editDeleteContainerRef.current) setShowEditDelete({});
    };

    const getConversations = async () => {
        try {
            const { result, error } = await emailHistory("document_sentiment");
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            result.forEach((item: any) => {
                if (item.title) {
                    const titleWithoutSuffix = item.title.split('___')[0];
                    const updatedTitle = titleWithoutSuffix.endsWith('.pdf') ? titleWithoutSuffix : `${titleWithoutSuffix}.pdf`;
                    item.title = updatedTitle;
                }
            });
            let sortedConversations: any;
            sortedConversations = result?.sort((a: any, b: any) => {
                const dateA: any = moment(a.created_at);
                const dateB: any = moment(b.created_at);
                return dateB - dateA;
            });
            // Group conversations by date
            const conversationsByDate: any = {};
            sortedConversations.forEach((conversation: any) => {
                const date = moment(conversation.created_at).format(
                    'YYYY-MM-DD'
                );
                if (!conversationsByDate[date]) {
                    conversationsByDate[date] = [];
                }
                conversationsByDate[date].push(conversation);
            });
            // Organize conversations into different phases
            const today = moment().format('YYYY-MM-DD');
            const yesterday = moment()
                .subtract(1, 'days')
                .format('YYYY-MM-DD');
            const previous7Days = moment()
                .subtract(7, 'days')
                .format('YYYY-MM-DD');
            const previous30Days = moment()
                .subtract(30, 'days')
                .format('YYYY-MM-DD');

            const organizedData: any = {};

            // Add conversations for "Today"
            organizedData['Today'] = conversationsByDate[today] || [];

            // Add conversations for "Yesterday"
            organizedData['Yesterday'] =
                conversationsByDate[yesterday] || [];

            // Add conversations for "Previous 7 days" excluding conversations in "Today" and "Yesterday"
            organizedData['Previous 7 days'] = Object.keys(
                conversationsByDate
            )
                .filter((date) =>
                    moment(date).isBetween(
                        previous7Days,
                        yesterday,
                        null,
                        '[]'
                    )
                )
                .map((date) => conversationsByDate[date])
                .flat()
                .filter((conversation) => {
                    const conversationDate = moment(
                        conversation.created_at
                    ).format('YYYY-MM-DD');
                    return (
                        conversationDate !== today &&
                        conversationDate !== yesterday
                    );
                });

            // Add conversations for "Previous 30 days" excluding conversations in "Previous 7 days"
            organizedData['Previous 30 days'] = Object.keys(
                conversationsByDate
            )
                .filter((date) =>
                    moment(date).isBetween(
                        previous30Days,
                        previous7Days,
                        null,
                        '[]'
                    )
                )
                .map((date) => conversationsByDate[date])
                .flat()
                .filter(
                    (conversation) =>
                        moment(conversation.created_at).format(
                            'YYYY-MM-DD'
                        ) !== today &&
                        moment(conversation.created_at).format(
                            'YYYY-MM-DD'
                        ) !== yesterday
                );

            // Organize conversations by month, excluding the current month
            const conversationsByMonth: any = {};
            sortedConversations.forEach((conversation: any) => {
                const month = moment(conversation.created_at).format(
                    'MMMM YYYY'
                );
                if (month !== moment().format('MMMM YYYY')) {
                    if (!conversationsByMonth[month]) {
                        conversationsByMonth[month] = [];
                    }
                    conversationsByMonth[month].push(conversation);
                }
            });

            // Add conversations by month to the organized data
            for (const month in conversationsByMonth) {
                organizedData[month] = conversationsByMonth[month];
            }
            setData(organizedData);
            // setData({})
        } catch (error) {
            toast.error(error as ToastContent<unknown>, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    };

    useEffect(() => {
        navigate(`/sentiment-analysis/${params.id}`);
        if (params.id !== 'new-sentiment' && params.id !== undefined) {
            handleGetConversation(params.id);
        }
    }, []);

    useEffect(() => {
        if (sentimentAnalysisPdf && !_.isEmpty(sentimentAnalysisPdf)) {
            fetchSentimentData();
        }
    }, [sentimentAnalysisPdf])

    let featureHistory: any = JSON.parse(localStorage.getItem("feature-flag") || '{}');
    const historyFlag = featureHistory[myconst.FEATURE_FLAG_KEY.history]

    const renderStars = (rating: any) => {
        const fullStars = Math.floor(rating); // Full stars
        const fractionalPart = rating % 1;

        let quarterStar = 0;
        let threeQuarterStar = 0;
        let halfStar = 0;

        if (fractionalPart >= 0.75) {
            threeQuarterStar = 1;
        } else if (fractionalPart >= 0.5) {
            halfStar = 1;
        } else if (fractionalPart >= 0.25) {
            quarterStar = 1;
        }
        const emptyStars = 5 - fullStars - quarterStar - halfStar - threeQuarterStar;
        return (
            <div className="stars">
                <div className="star-wrapper">
                {[...Array(fullStars)].map((_, i) => (
                    <i key={`full-${i}`} className="fa fa-star full-star" />
                ))}

                {threeQuarterStar === 1 && (<i key="threeQuarter" className="fa fa-star three-quarter-star" />)}

                {halfStar === 1 && (
                    <i key="half" className="fa fa-star half-star" />
                )}

                {quarterStar === 1 && (<i key="quarter" className="fa fa-star quarter-star" />)}

                {[...Array(emptyStars)].map((_, i) => (
                    <i key={`empty-${i}`} className="fa fa-star empty-star" />
                ))}
                </div>
            </div>
        )
    }

    const handleSearch = (query: any) => {
        const lowerCaseQuery = query.toLowerCase();

        const filtered = sentimentData?.filter((item: any) => {
            const reviewText = item.Review.toLowerCase();
            const rating = item.Rating.toLowerCase();
            const sentiment = item.Sentiment.toLowerCase();
            return (
                reviewText.includes(lowerCaseQuery) ||
                rating.includes(lowerCaseQuery) ||
                sentiment.includes(lowerCaseQuery)
            );
        })
        return filtered;
    }

    const handleChangeSearchFilter = (e: any) => {
        let searchTerm = e.target.value;
        setSearchItem(searchTerm)
    } 

    const handleKeyDown = (e: any) => {
        if (e.key === 'Enter') {
            handleFilter(filterRating, filterSentiment, searchItem); 
        }
    };
    
    const handleSearchFilter = (e: any) => {
        // let searchTerm = e.target.value;
        // if (searchTerm === "" || /^\s*$/.test(searchTerm)) {
        //     if (reviewsRef.current) {
        //         reviewsRef.current.scrollTo({ top: 0, behavior: 'smooth' });
        //     }
        //     setSearchItem("");
        //     setFilteredData(sentimentData)
        //     return;
        // }
        // if (reviewsRef.current) {
        //     reviewsRef.current.scrollTo({ top: 0, behavior: 'smooth' });
        // }
        // setSearchItem(searchTerm);
        handleFilter(filterRating, filterSentiment, searchItem); 
        // const results = handleSearch(searchTerm);
        // setFilteredData(results);
    }

    return (
        <>
            {(sentimentAnalysisPdf && !_.isEmpty(allSentimentData)) && <>
                <div className='ali mycalls-head sentiment-filters'>
                    <div className="mycalls-head-right">
                        <div className='d-flex- align-items-center mt-1 mb-1 mr-4'>
                            <div className="search-bar-container">
                                <span className="p-input-icon-left">
                                    <i className="pi pi-search" />
                                </span>
                                <InputText
                                    value={searchItem}
                                    onChange={handleChangeSearchFilter}
                                    onKeyDown={handleKeyDown}
                                    placeholder="Search"
                                    className="search-input"
                                />
                                <Button 
                                    label="Search" 
                                    className="search-button" 
                                    // disabled={!searchItem.trim()} 
                                    onClick={handleSearchFilter}
                                />
                            </div>
                        </div>
                        <div className='voice-filter-col mt-1 mb-1'>
                            <Dropdown value={filterRating} style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none" }} onChange={(e) => handleRatingFilter(e)} options={ratings} optionLabel="name" 
                            placeholder="Rating" className="w-full md:w-14rem fw-bold text-sm" />
                        </div>
                        <div className='voice-filter-col mt-1 mb-1'>
                            <Dropdown value={filterSentiment} style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none" }} onChange={(e) =>  handleSentimentFilter(e)} options={sentiments}
                                placeholder="Sentiment" optionLabel="name" className="w-full md:w-14rem fw-bold text-sm"
                            />
                        </div>
                    </div>
                </div>
            </>}
            <section
                className={`chat-component-main-section documate-main-section sentiment-container`}
            >
                {(sentimentAnalysisPdf && !_.isEmpty(allSentimentData)) && <>
                    <div className='chat-component-main-container sentiment-analysis-container'>
                        <div className='chats-conversation-container' ref={reviewsRef}>
                            <h4 className='reviews-heading'>Reviews</h4>
                            <div className='sentiment-analysis-ratings-section'>
                                <div className='sentiment-analysis-ratings'>
                                    <p className='total-section'>
                                        <span>Total Reviews</span>
                                        {allSentimentData?.total_reviews}
                                    </p>
                                    <p className='average-header'>
                                        <span>Average Rating</span>
                                        <div className='average-rating-section'>{allSentimentData?.avg_rating}
                                            {renderStars(allSentimentData?.avg_rating)}
                                        </div>
                                    </p>
                                    {totalRatings === 0
                                        ? <p className='no-ratings'>No ratings available</p>
                                        : <div className='star-reviews'>
                                            {Object.entries(allSentimentData?.rating_count)
                                                .sort(([a]: any, [b]: any) => b - a)
                                                .map(([key, value]: any) => {
                                                    const percentage = (value / totalRatings) * 100;
                                                    let progressColor;

                                                    switch (key) {
                                                        case "1":
                                                            progressColor = "#DB3447";
                                                            break;
                                                        case "2":
                                                            progressColor = "#0D73F8";
                                                            break;
                                                        case "3":
                                                            progressColor = "#FBD008";
                                                            break;
                                                        case "4":
                                                            progressColor = "#C350F1";
                                                            break;
                                                        case "5":
                                                            progressColor = "#6FBE46";
                                                            break;
                                                        default:
                                                            progressColor = "gray";
                                                    }

                                                    return (
                                                        <div key={key} className='count-section'>
                                                            <span className='rating-count'>
                                                            <i className="fa fa-star empty-star" />
                                                            {key}</span>
                                                            <div className='progress-bar'>
                                                                <div className='inner-progress-bar'
                                                                    style={{
                                                                        width: `${percentage}%`,
                                                                        backgroundColor: progressColor // Apply the color dynamically
                                                                    }}
                                                                />
                                                            </div>
                                                            <span className='rating-value'>{new Intl.NumberFormat('en-US').format(value)}</span>
                                                        </div>
                                                    )
                                                })}
                                        </div>
                                    }
                                </div>
                            </div>
                            {filteredData && filteredData.length > 0 ? (
                            filteredData?.map((data: any) => {
                                const productMatch = data.Review.match(/Product:\s*(.*)/);
                                const productName = productMatch ? productMatch[1] : null;
                                const sentimentsArray = data.Sentiment.trim().split('\n').map((sentiment: string) => sentiment.trim());
                                const cleanedReview = productName ? data.Review.replace(/Product:\s*.*$/, '').trim() : data.Review;

                                const sentiments = sentimentsArray.map((sentiment: string, index: number) => {
                                    const sentimentClass = sentiment.toLowerCase() === 'positive'
                                        ? 'joy-text'
                                        : sentiment.toLowerCase() === 'negative'
                                            ? 'anger-text'
                                            : 'natural-text';

                                    const hasMultipleSentiments = sentimentsArray.length > 1;

                                    return (
                                        <span
                                            key={index}
                                            className={sentimentClass}
                                            style={hasMultipleSentiments ? { marginRight: '10px' } : {}}
                                        >
                                            {sentiment.charAt(0).toUpperCase() + sentiment.slice(1)}
                                        </span>
                                    );
                                });

                                return (
                                    <div className='review-container'>
                                        <p className='rating-section'>
                                            <span className='review-star-rating'>
                                                {renderStars(parseFloat((data?.Rating).split('/')[0]))}
                                            </span>
                                            <span className='sentiment-section'>{sentiments}</span>
                                        </p>
                                        {productName && (
                                            <span className='product-name'>
                                                {productName}
                                            </span>
                                        )}
                                        <p className='review-section'>{cleanedReview}</p>
                                    </div>
                                )
                            })): (
                                <div className='no-results-found'>
                                   No reviews found
                                </div>
                            )}
                            {filteredData.length > 0 &&
                                <div className="response-details">
                                    <p className='response-time'>
                                        {moment(
                                            allSentimentData?.created_at
                                        ).format(
                                            'MMM DD, YYYY HH:mm:ss'
                                        )}
                                    </p>
                                </div>
                            }
                        </div>
                    </div>
                    <div className='uploded-pdf'>
                        {sentimentAnalysisPdf !== "" &&
                            <div className='pdf-viewer-wrapper'>
                                <div className='pdf-viewer-header'>
                                    {(<strong className='text-sm fw-semibold flex align-items-center' title={sentimentFileName} >
                                        {sentimentFileName?.length > 17
                                            ? `${sentimentFileName?.slice(0, 17 / 2)}...${sentimentFileName?.slice(-17 / 2)}`
                                            : sentimentFileName}
                                    </strong>)
                                    }
                                    {/* <strong><span>Lorem_ipsum</span>.pdf<i><img data-tooltip-content="Share" src={shareIcon} alt="share" /></i></strong> */}
                                    {/* <div className='pdf-lang fw-semibold'><i><img src={languageIcon} alt='qmate-icon' /></i></div> */}
                                </div>
                                <iframe
                                    title="PDF Viewer"
                                    src={sentimentPdf}
                                    width="100%"
                                    height="500px"
                                    frameBorder="0"
                                    allowTransparency={true}
                                />
                            </div>
                        }
                    </div>
                </>}
                {(historyFlag === true || historyFlag === undefined) &&
                        <>
                            <Button label="Chat History" outlined icon="pi pi-history" className='outline-icon-btn chat-history-btn' onClick={() => setVisibleRight(true)} />
                            <ConversationList
                                current={current}
                                setCurrent={setCurrent}
                                handleGetConversation={handleGetConversation}
                                data={data}
                                setVisibleRight={setVisibleRight}
                                visibleRight={visibleRight}
                                setData={setData}
                                hover={hover}
                                showEditDelete={showEditDelete}
                                setShowEditDelete={setShowEditDelete}
                                setHover={setHover}
                                getConversations={getConversations}
                                handleDelete={handleDelete}
                                handleDeleteIconClicked={handleDeleteIconClicked}
                                emailData={emailData}
                                setEmailData={setEmailData}
                                component={"sentiment-analysis"}
                                source_name={"document_sentiment"}
                            />
                        </>
                }
            </section>
            <Modal
                date={deleteConfirmation?.date}
                index={deleteConfirmation?.index}
                handleDelete={handleDelete}
                onCancel={() => {

                    const updatedIsDeleteClicked: any = [...isDeleteClicked];

                    updatedIsDeleteClicked[
                        deleteConfirmation.index
                    ] = false;

                    setIsDeleteClicked(updatedIsDeleteClicked);

                }}
                promptText={promptText}
            />
        </>
    );
}

export default SentimentAnalysis;